<template>
  <div>
    <app-title>{{$route.params.report}}</app-title>
    <customer-orders v-if="$route.params.report == 'CustomerOrders'">Customer Order Report</customer-orders>
    <v-spacer/>
    <customer-listing v-if="$route.params.report == 'CustomerListing'">Customer List</customer-listing>
    <v-spacer/>
    <sales-volume v-if="$route.params.report == 'SalesVolume'">Sales Volume</sales-volume>
    <v-spacer/>
    <sales-summary v-if="$route.params.report == 'SalesVolumeSummary'"></sales-summary>
  </div>
</template>

<script>
export default {
  name: "ListReports",
  components: {
    CustomerListing: () => import("@/components/customer/customer-listing.vue"),
    CustomerOrders: () => import("@/components/customer/customer-orders.vue"),
    SalesVolume: () => import("@/components/customer/sales-volume.vue"),
    SalesSummary: () => import("@/components/customer/sales-volumeSummary.vue")
  },
  data() {
    return {};
  }
};
</script>

<style scoped>
</style>
